@if (!showMultipleWallets()) {
  <!--Search Bar and Currency Filter-->
  <div class="trade-modal__padding">
    <div class="search-toolbar">
      <span class="search-icon bpi__icon-magnifying-glass"></span>
      <input
        [type]="'search'"
        class="search-input-field"
        [(ngModel)]="searchInputValue"
        (keyup)="onSearchKeyUp()"
        placeholder="{{ 'search_bar_placeholder_' + getAction() | translate }}" />
    </div>
    @if (action !== 'voucher') {
      <div class="mb-20">
        <currency-filter
          [keepVisibility]="true"
          (onSelect)="onFilter($event)"
          [currencyTypes]="currencyFilterTypesFF$ | async"
        [filterType]="filterType"></currency-filter>
      </div>
    }
  </div>
  @if (isBuyAction() && pillsThatNeedRealSecuritiesBanner | include_pipe: filterType.currencyType) {
    <div class="margin-real-securities-banner">
      <real-securities-banner
        [title]="'inline_banner_real_securities_watchlist_title' | translate"
        [subtitle]="'inline_banner_real_securities_coming_soon_web' | translate"
        />
    </div>
  }
  <!--Asset Selection List-->
  <div
		[ngClass]="{
			'favourites-list-container': isFavourites,
			'tradable-list-item__scrollable': hasInfiniteScrollSupport()
		}"
    class="pb-60">
    <div class="tradable-list-item__legend_container item_padding">
      <div
        class="tradable-list-item__legend_name font-size-modifier"
        [ngClass]="{ 'favourites-name-padding': isFavourites }">
        {{ "tradable_list_selection_legend_name" | translate }}
      </div>
      <div class="tradable-list-item__legend__detail_wrapper" [ngClass]="{ 'mod-sell': !isBuyAction() }">
        <div class="items-center font-size-modifier">
          {{ "tradable_list_selection_legend_" + (isBuyAction() ? "simple_change" : "own") | translate }}
          @if (showChangeTooltip()) {
            <span
              class="bpi__icon-info"
            [bp-tooltip]="'tradable_list_selection_change_tooltip_info' | translate"></span>
          }
        </div>
        <div class="pr-10 font-size-modifier">
          {{ "tradable_list_selection_legend_" + (isBuyAction() ? "price" : "value") | translate }}
        </div>
      </div>
    </div>
    <div class="tradable-list-item__border"></div>
    @for (fiat of getFiatWalletList() | async; track fiat) {
      <div
        class="tradable-list-item__item_container item_padding"
        (keydown.enter)="onFiatClick(fiat)"
        (click)="onFiatClick(fiat)"
        [tabindex]="0">
        <div class="tradable-list-item__item_tradable_info">
          <div class="pr-10 pt-4">
            <img
              class="image-size"
              [src]="getFiatFromWallet(fiat)?.getLogo()"
              (error)="img.src = getFiatFromWallet(fiat)?.getDefaultLogo()"
              alt="{{ 'logo_alt_text' | translate }}"
              #img />
          </div>
          <div class="color-text grid-setup">
            <div
              class="tradable-list-item__item_tradable_icon_name tradable-list-item__item_tradable_icon_ellipsis">
              {{ getFiatFromWallet(fiat).getName() }}
            </div>
          </div>
        </div>
        <div class="tradable-list-item__item_tradable_details mod-sell">
          <div class="tradable-list-item__item_tradable_change_text mod-owned">
            <ng-container>
              {{
              fiat?.getBalance() + fiat?.getCashPlusBalance()
              | fiat_precision_symbol
              : {
              id: getFiatFromWallet(fiat)?.getId(),
              currencies: [getFiatFromWallet(fiat)]
            }
            }}
          </ng-container>
        </div>
        <div class="pr-10 tradable-list-item__item_tradable_icon_fiat text-right mod-owned">
          {{
          convertBalanceToDefaultFiat(fiat) + fiat?.getCashPlusBalance()
          | fiat_precision_symbol
          : { id: getDefaultFiat()?.getId(), currencies: [getDefaultFiat()], symbol: true }
          }}
        </div>
      </div>
    </div>
    <div class="tradable-list-item__border"></div>
  }
  @if (isMultichain === false) {
    @for (tradable of getTradableList() | async; track tradable; let isLast = $last) {
      <div
        (scrolledIntoView)="fetchListUpdate()"
        [elementIsIntoView]="isLast"
        class="tradable-list-item__item_container item_padding"
        accessibleElement
        (addAccessibleElement)="updatedWalletList.emit($event)"
        (keydown.enter)="isFavourites ? onFavouritesItemClick(tradable) : onItemClick(tradable)"
        (click)="isFavourites ? onFavouritesItemClick(tradable) : onItemClick(tradable)"
        [tabindex]="0">
        <div class="tradable-list-item__item_tradable_info">
          @if (!!isFavourites) {
            <div class="favourites_icon_container">
              <img
                class="tradable-list-item__item_tradable_icon_favourites_icon"
                [src]="getIconPath(tradable)"
                alt="{{ 'logo_alt_text' | translate }}" />
            </div>
          }
          <div class="pr-10 pt-4" [ngClass]="{ logo_padding_favourites: isFavourites }">
            <img
              class="image-size"
              [src]="tradable.getLogo()"
              (error)="img.src = tradable.getDefaultLogo()"
              alt="{{ 'logo_alt_text' | translate }}"
              #img />
          </div>
          <div class="color-text grid-setup">
            <div
              class="tradable-list-item__item_tradable_icon_name tradable-list-item__item_tradable_icon_ellipsis"
              [ngClass]="{ 'name-width-buy': isBuyAction() }">
              {{ tradable?.getName() }}
            </div>
            <div class="tradable-list-item__item_tradable_icon_text">
              {{ tradable?.getSymbol(false, true) }}
            </div>
          </div>
        </div>
        <div class="tradable-list-item__item_tradable_details" [ngClass]="{ 'mod-sell': !isBuyAction() }">
          @if (!isBuyAction()) {
            <div class="tradable-list-item__item_tradable_change_text mod-owned">
              {{ getWalletSum(tradable) | tradable_precision_symbol: { id: tradable?.getId() } }}
            </div>
            <div class="pr-10 tradable-list-item__item_tradable_icon_fiat mod-owned">
              {{
              getWalletSumFiat(tradable)
              | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] }
              }}
            </div>
          } @else {
            <div
              class="tradable-list-item__item_tradable_change_text"
								[ngClass]="{
									'mod-color-positive': isChangePositive(tradable),
									'mod-color-negative': isChangeNegative(tradable),
									'mod-color-default': !isChangePositive(tradable) && !isChangeNegative(tradable)
								}">
              {{
              getAbsoluteChange(tradable)
              | fiat_precision
              | value_change_prefix
              : {
              isProfit: isChangePositive(tradable),
              noChange: !isChangePositive(tradable) && !isChangeNegative(tradable)
            }
            | percent_symbol
            }}
          </div>
          <div class="pr-10 tradable-list-item__item_tradable_icon_fiat">
            {{
            getAveragePrice(tradable)
            | fiat_precision_symbol
            : { id: fiat?.getId(), symbol: true, currencies: [fiat, tradable] }
            }}
          </div>
        }
      </div>
    </div>
    <div class="tradable-list-item__border"></div>
  }
} @else {
  @for (mTradeable of multichainAssetWalletInfo | async; track mTradeable) {
    <div
      class="tradable-list-item__item_container item_padding"
      [tabindex]="0"
      (click)="clickedMultichainTradable(mTradeable)"
      (keydown.enter)="clickedMultichainTradable(mTradeable)">
      <div class="flex flex-row">
        <div class="pr-10 pt-4">
          <img class="image-size" [src]="mTradeable?.asset.logo" alt="{{ 'logo_alt_text' | translate }}" />
        </div>
        <div class="color-text grid-setup">
          <div
            class="tradable-list-item__item_tradable_icon_name tradable-list-item__item_tradable_icon_ellipsis">
            {{ mTradeable?.asset.name }}
          </div>
          <div class="tradable-list-item__item_tradable_icon_text">
            {{ mTradeable?.asset.symbol | uppercase }}
          </div>
        </div>
      </div>
      <div class="tradable-list-item__item_tradable_details mod-sell">
        @if (!isBuyAction()) {
          <div class="tradable-list-item__item_tradable_change_text mod-owned">
            {{
            mTradeable?.walletSum
            | tradable_precision_symbol: { id: mTradeable?.asset.cryptocoin_id.toString() }
            }}
          </div>
          <div class="pr-10 tradable-list-item__item_tradable_icon_fiat mod-owned">
            {{
            mTradeable?.walletSumFiat
            | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] }
            }}
          </div>
        }
      </div>
    </div>
    <div class="tradable-list-item__border"></div>
  }
}
@if (hasInfiniteScrollSupport()) {
  @if (isLoading$ | async) {
    <loading-spinner></loading-spinner>
  }
  @if (hasError$ | async) {
    <tradable-list-empty [filteredList$]="getTradableList()" (refetchData)="refetchList()">
    </tradable-list-empty>
  }
}
</div>
} @else {
  <tradable-wallet
    [ngClass]="'modal-grid mod-two-cols'"
    [action]="getAction()"
    [tradableWallets]="getWalletList() | async"
    (onSelect)="emitSelectedWallet($event)"
    [(tradableId)]="tradableId">
  </tradable-wallet>
}
<!--Specific Wallet Selection for Wallet Stacks-->

